import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
function LocationsProfileComponent(props) {
  const { provider } = props;
  return (
    (provider.tenancies &&
      provider.tenancies.map(item => {
        return (
          <div>
            {/* <Typography>
              {' '}
              {item.locationShortName}
              <span style={{ backgroundColor: item.color }}> </span>
            </Typography> */}
            <Typography> {item.location}</Typography>
          </div>
        );
      }) || null
    ))
}


LocationsProfileComponent.PropTypes = {
  provider: PropTypes.func,
};

export default LocationsProfileComponent;
